import Activity from '@/services/Actividades'
import axios from '@/utils/axios'

const actions = {
  async datosCalendario (context: any) {
    const tareas = new Activity(axios)

    try {
      const combinedData = await tareas.getListar()
      context.commit('datos', { datos: combinedData })
      localStorage.setItem('eventos', JSON.stringify(combinedData))
    } catch (error: any) {

    }
  }
}

export default actions
